<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            老人充值列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">老人充值</el-button>
                    <div style="float:right">
                        <el-input  placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
                        <el-select v-model="rechargeType" placeholder="请选择充值类型" style="width:200px;margin-right:10px">
                            <el-option
                                    v-for="item in typeValue"
                                    :key="item[0]"
                                    :label="item[1]"
                                    :value="item[0]">
                            </el-option>
                        </el-select>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            style="margin-right:10px;"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期" class="search">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期" class="search">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
                
            </div>
            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">
                        <el-table-column label="老人姓名" prop="elderlyName" width="100"></el-table-column>
                        <el-table-column label="手机号" prop="elderlyDTO.phone"></el-table-column>
                        <el-table-column label="身份证号" prop="elderlyDTO.idCard" width="180"></el-table-column>
                        <el-table-column label="地区" prop="elderlyDTO.areaName" ></el-table-column>
                        <el-table-column label="详细地址" prop="elderlyDTO.address" ></el-table-column>
                        <!-- <el-table-column prop="elderlyDTO.balance"  width="100" label="余额(元)"></el-table-column> -->
                        <el-table-column prop="addBalance" label="充值金额（元）" width="150"></el-table-column>
                        <el-table-column prop="rechargeType" :formatter="getType" label="充值类型" width="150"></el-table-column>
                        <el-table-column prop="remarks"  label="备注" width="150"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="充值时间"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:zoneValue="zoneValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    </div>
</template>

<script>

    import {timeStr,timefilters,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                menuButtonList:null,
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
                disabledAdd:true,
                showModalAdd:false,
                batchDialog:false,
                tableData:null,
                elderlyName:null,
                rechargeType:-1,
                batchFileList:[],
                zoneValue:[],
                typeValue:[[-1,'全部充值类型'],[1,'现金'],[2,'支付宝'],[3,'微信'],[4,'刷卡'],[11,'系统自动充值']],
                datetimerangeValue:[],
                uploadUrl:this.$institutionUrl+'ImportExcel/RechargeImport',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
            }
        },
        components:{
            Add
        },
        
        created(){
            this.init();
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="老人充值"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            init(){
                const end= new Date();
                const start=new Date(end.getTime() - 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=[start, end];
            },
            formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getType(row){
                let data=''
                this.typeValue.forEach(element => {
                    if(element[0]==row.rechargeType){
                        data=element[1]
                    }
                });
                return data
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RechargeRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        rechargeType:this.rechargeType,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            submitUpload(){
                this.$refs.upload.submit();
            },
            closeBatchDialog(){
                this.$refs.upload.clearFiles();
            },
            handleRemove(){

            },
        }
    }
</script>

<style lang="scss" scoped>


</style>
